<template>
  <v-navigation-drawer
    v-model="drawer"
    right
    temporary
    fixed
    touchless
  ></v-navigation-drawer>
</template>

<script>
export default {
  data () {
    return {
      right: false
    }
  },
  computed: {
    drawer: {
      get () {
        return this.$store.state.navRightExtra
      },
      set (val) {
        this.$store.commit('openNavRightExtra', val)
      }
    }
  }
}
</script>
